import React from 'react';

import { Translate } from 'react-localize-redux';
import AppState from '@webapp/store/state';
import {
  CreateRosterOperator,
  RemoveOperatorFromRoster,
} from '@webapp/store/rosters/action-creators';
import { RostersState } from '@webapp/store/rosters/state';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { RosterOperator } from '@services/rosters/types/roster-operator';
import User from '@common/types/user/user';
import { Roster } from '@services/rosters/types/roster';
import OperatorLabelInviteCtrl from '../../operator-label-invite';
import { UserSearchResult } from '@webapp/types/user-search-result';
import { normalizePhoneOrEmail } from '@webapp/utils/normalizers';
import OperatorItem from '../operator-item';

interface RosterOperatorsProps {
  className?: string;
  operators: RostersState['operators'];
  createOperator: (
    rosterId: string,
    userName: string,
    userId: string
  ) => CreateRosterOperator;
  removeOperator: (
    rosterId: string,
    operatorId: string
  ) => RemoveOperatorFromRoster;
  roster: Roster;
  ownerId: string;
  inviter?: Partial<User>;
}

const mapStateToProps = (state: AppState) => ({
  operators: state.rosters.operators,
  inviter: state.user.profile,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  createOperator: (rosterId: string, userName: string, userId: string) =>
    dispatch(new CreateRosterOperator(rosterId, userName, userId)),
  removeOperator: (labelId: string, userId: string) =>
    dispatch(new RemoveOperatorFromRoster(labelId, userId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(function RosterOperators(props: RosterOperatorsProps) {
  const [newOperator, setNewOperator] =
    React.useState<Partial<UserSearchResult>>();

  const getLabelOperators = (rosterId: string) => {
    return props.operators[rosterId] || [];
  };

  const operatorAsUser = (operator: RosterOperator): UserSearchResult => {
    return {
      id: operator.userId,
      name: operator.userName,
      avatar: '',
      contact: '',
      type: operator.userId ? 'user' : 'invite',
      helpText: operator.userName,
    };
  };

  const handleSelection = (operator: UserSearchResult) => {
    setNewOperator(undefined);
    const contact = normalizePhoneOrEmail(operator.contact);

    if (!contact) {
      return;
    }
  };

  return (
    <>
      <OperatorLabelInviteCtrl
        label={<Translate id="USER_PROFILE.ROSTER.OPERATOR.NEW" />}
        className={`${
          getLabelOperators(props.roster.id).length >= 1 ? 'mb-40' : ''
        }`}
        value={newOperator as UserSearchResult}
        currentValues={getLabelOperators(props.roster.id).map(operatorAsUser)}
        role="operator"
        type="operator"
        onChange={(value) => setNewOperator({ ...newOperator, name: value })}
        onSelection={(operator) => handleSelection(operator)}
        songName=""
      />
      {getLabelOperators(props.roster.id).map((operator) => (
        <OperatorItem
          key={operator.userId}
          name={operator.userName}
          labelId={operator.rosterId}
          userId={operator.userId}
          onRemove={props.removeOperator}
        />
      ))}
    </>
  );
});
